import React, { Component, useRef } from 'react';
import axios from 'axios';
import withRouter from '../../../Utils/withRouter';
import { convertTo12HourFormat, formatDate, formatTime, getDaysDifference, getHoursAndMinutes, isNegativeDeviation, TextBox } from '../../../Components/InputElements';
import PageTitle from "../../../Components/PageTitle";
import { ConfigContext } from '../../../Context/ConfigContext';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx'
import Select from 'react-select';
import { NoRecords } from '../../../Components/Shimmer';
import { NavLink } from 'react-router-dom';
import { currentDateAndTime,decodeData, getFullYearMonthArray } from '../../../Constants/constants';

class TeamsAttendanceReport extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            employee_id: 0,
            employee_attendance_id: 0,
            attendance_regularization_request_id: 0,
            modal_type: 1,
            location_id: '',
            department_id: '',
            remark_by_employee: '',
            punch_in_datetime: "",
            punch_out_datetime: "",
            rows: [],
            logs_data: [],
            rz_data: [],
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            loadingList: false,
            keyword: "",
            from_date: "",
            to_date: "",
            selectOption: "",
            month: parseInt(currentDateAndTime()?.split(" ")[0]?.split("-")[1]),
            monthOptions: [],
            department_rows: [],
            location_rows: [],
            selectedRows: [],
            loadingLocation: false,
            position: [],
            punch_in_date: null,
            punch_in_time: null,
            punch_out_address: '',
            punch_in_address: null,
            punch_out_date: null,
            punch_out_time: null,
            decodedData: [],
        };
        this.modalRef = React.createRef();
        this.closeRef = React.createRef();
        this.attendanceLocationInfoRef = React.createRef();
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
            this.GetDepartmentList();
            this.GetLocationList();
            this.GetRegularizationSettings();
        });
        let date = currentDateAndTime();
        let monthOpt = getFullYearMonthArray(date);
        this.setState({ monthOptions: monthOpt });
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.permissions !== this.context.permissions) {
            console.log("Permissions Updated:", this.context.permissions);
            const { permissions } = this.context;
            if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                console.log("encodedData",encodedData);
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                console.log("decodedData",decodedData);
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({ decodedData });
                }
            } else {
                console.warn("Permissions not yet available. Retrying...");
            }
        }
    }

    GetDepartmentList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetAllMasters`, { headers })
            .then((response) => {
                var data = response.data;
                if (response.data.success === true) {
                    this.setState((prevState) => ({
                        department_rows: data.companies__departments.map((row) => ({
                            value: row.department_id,
                            label: row.department_title
                        }))
                    }));
                }
            });
    }
    scrollToDiv = () => {
        if (this.attendanceLocationInfoRef.current) {
            this.attendanceLocationInfoRef.current.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'center',
            });
          }
      };
    GetLocationList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Home/GetAllMasters`, { headers })
            .then((response) => {
                var data = response.data;
                if (response.data.success === true) {
                    this.setState((prevState) => ({
                        location_rows: data.companies__locations.map((row) => ({
                            value: row.location_id,
                            label: row.location_title
                        }))
                    }));
                }
            });
    }

    GetLocation = () => {
        console.log(this.state.position);
        this.setState({ loadingLocation: true });
        axios.get(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${this.state.position[0]}&lon=${this.state.position[1]}&zoom=18&addressdetails=1`).then((response) => {
            var data = response.data;
            if (response.data !== 0) {
                setTimeout(() => {
                    // Code to execute after 1 second
                    this.setState({
                        display_name: data.display_name,
                        city: data.address.city,
                        loadingLocation: false,
                    });
                    
                }, 500);
            } else {
                this.setState({ loadingLocation: false });
            }
        });
    }

    showInMap = (positionString, punch_in_date, punch_in_time, punch_in_address) => {
        if (!positionString) {
            return
        }
        const positionArray = positionString.split(',').map(Number);
        console.log(positionArray);
        this.setState({
            position: positionArray,
            punch_in_date: punch_in_date,
            punch_in_time: punch_in_time,
            punch_out_address: '',
            punch_in_address: punch_in_address,
            punch_out_date: null,
            punch_out_time: null,
        }, () => {
            this.GetLocation();
        });

    }
    showOutMap = (positionString, punch_out_date, punch_out_time, punch_out_address) => {
        if (!positionString) {
            return
        }
        const positionArray = positionString.split(',').map(Number);

        this.setState({
            position: positionArray,
            punch_out_date: punch_out_date,
            punch_out_time: punch_out_time,
            punch_in_address: '',
            punch_out_address: punch_out_address,
            punch_in_date: null,
            punch_in_time: null,
        }, () => {
            this.GetLocation();
        });

    }

    checkIsLeave = (data) => {
        const leaveFromDate = data.employee_leave_from_date;
        const leaveToDate = data.employee_leave_to_date;
        let created_datetime = data.created_date;
        const createdDate = created_datetime.split(' ')[0];

        if (data.employee_leave_id) {
            if (createdDate === leaveFromDate) {
                return data.employee_leave_from_day_unit === "First Half" ? ' / 1' : data.employee_leave_from_day_unit === "Second Half" ? ' / 2' : '';
            }
            if (createdDate === leaveToDate) {
                return data.employee_leave_to_day_unit === "First Half" ? ' / 1' : data.employee_leave_from_day_unit === "Second Half" ? ' / 2' : '';
            }
        } else {
            return '';
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        const formatDateTime = (isoDateString) => {
            const date = new Date(isoDateString);
            const formattedDate = date.toISOString().split("T")[0];
            const formattedTime = date.toTimeString().split(" ")[0];
            return `${formattedDate} ${formattedTime}`;
        };

        // Format punch_in_datetime and punch_out_datetime
        const formattedPunchInDateTime = formatDateTime(this.state.punch_in_datetime);
        const formattedPunchOutDateTime = formatDateTime(this.state.punch_out_datetime);

        // Get current date and time for regularized_datetime
        const currentDateTime = new Date();
        const formattedRegularizedDateTime = formatDateTime(currentDateTime.toISOString());

        var formData = {
            employee_id: this.state.employee_id,
            employee_attendance_id: this.state.employee_attendance_id,
            regularization_request_remark: JSON.stringify({
                "punch_in_datetime": formattedPunchInDateTime,
                "punch_out_datetime": formattedPunchOutDateTime,
                "remark": this.state.remark_by_employee,
            }),
            regularized_datetime: formattedRegularizedDateTime,
            remark_by_employee: this.state.remark_by_employee,
        };

        axios.post(`${apiURL}Attendance/RegularizationRequest`, formData, { headers }).then((response) => {
            const { success } = response.data;

            if (success === true) {
                this.setState({
                    employee_attendance_id: 0,
                    employee_id: 0,
                    punch_in_datetime: '',
                    punch_out_datetime: '',
                    remark_by_employee: '',
                });
                this.closeRef.current.click();
                this.GetList();
                Swal.fire({
                    title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    timer: 2000,
                    timerProgressBar: true,
                    showConfirmButton: false,
                })
            } else {
                Swal.fire({
                    title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    timer: 2000,
                    timerProgressBar: true,
                    showConfirmButton: false,
                })
                this.setState({ loadingList: true }, (prevState) => {
                    this.GetList();
                })
            }
        });
    };

    formatGetedDateTime = (dateTimeString) => {
        const date = new Date(dateTimeString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    }

    GetRegularizationSettings = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Attendance/GetRegularizationSettings`, { headers }).then((response) => {
            const { data, success } = response.data;
            if (success === true && data.length != 0) {
                this.setState({
                    rz_data: data[0],
                });
            }
        });
    }

    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        axios.get(`${apiURL}Attendance/GetMyTeamAttendance`, {
            params: {
                limit: this.state.limit,
                page: this.state.page,
                keyword: this.state.keyword,
                from_date: this.state.from_date,
                to_date: this.state.to_date,
                attendance_status: this.state.selectOption,
                location_id: this.state.location_id,
                department_id: this.state.department_id,
                month: this.state.month,
                date: currentDateAndTime(),
            },
            headers,
        })
            .then((response) => {
                var data = response.data;
                if (response.data.success === true) {
                    this.setState({
                        rows: data.data,
                        next: data.next,
                        prev: data.prev,
                        page: data.page,
                        total_records: data.total_records,
                        total_pages: data.total_pages,
                        loadingList: false,
                    });
                } else {
                    this.setState({ loadingList: false });
                }
            });
    };


    GetInfo = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Attendance/GetEmployeeAttendanceInfo`, {
            params: {
                employee_attendance_id: this.state.employee_attendance_id,
                employee_id: this.state.employee_id,
            }, headers
        }).then((response) => {
            const { data, success } = response.data;
            if (success === true) {
                const punchInDateTime = data[0].punch_in_datetime;
                const punchOutDateTime = data[0].punch_out_datetime;

                // Format punch_in_datetime
                const formattedPunchInDateTime = this.formatGetedDateTime(punchInDateTime);

                // Format punch_out_datetime only if it's not null
                let formattedPunchOutDateTime = null;
                if (punchOutDateTime !== null) {
                    formattedPunchOutDateTime = this.formatGetedDateTime(punchOutDateTime);
                }

                this.setState({
                    punch_in_datetime: formattedPunchInDateTime,
                    punch_out_datetime: formattedPunchOutDateTime,
                    remark_by_employee: data[0].remark_by_employee,
                });
            }
        });
    }

    GetRegularizationLogs = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Attendance/GetRegularizationLogs`, {
            params: {
                attendance_regularization_request_id: this.state.attendance_regularization_request_id,
            }, headers
        }).then((response) => {
            const { data, success } = response.data;
            if (success === true) {
                this.setState({
                    logs_data: data,
                });
            }
        });
    }

    handleExcelDownload = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        Swal.fire({
            title: 'Please wait...',
            html: 'Your file is being prepared for download.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        axios.get(`${apiURL}Attendance/GetMyTeamAttendance`, {
            params: {
                limit: this.state.total_records,
                page: 1,
                keyword: this.state.keyword,
                from_date: this.state.from_date,
                to_date: this.state.to_date,
                attendance_status: this.state.selectOption,
                location_id: this.state.location_id,
                department_id: this.state.department_id,
                month: this.state.month,
                date: currentDateAndTime(),
            },
            headers,
        }).then((response) => {
            if (response.data.success === true) {
                const rows = response.data.data;

                const data = rows.map(row => ({
                    'Employee Code': row.employee_code,
                    'Employee Name': row.employee_name,
                    'Date': formatDate(row.Date),
                    'Punch In': ` ${formatDate(row.PunchIn)} - ${formatTime(row.PunchIn)}`,
                    'Punch Out': ` ${formatDate(row.PunchOut)} - ${formatTime(row.PunchOut)}`,
                    'Shift': `${convertTo12HourFormat(row.ShiftStart)} - ${convertTo12HourFormat(row.ShiftEnd)}`,
                    'Working Hours': getHoursAndMinutes(row.WorkingHours),
                    'Deviation': getHoursAndMinutes(row.Deviation),
                    'Location': row.location_title,
                    'Department': row.department_title,
                    'Attendance Status': row.AttendanceStatus,
                    'Action Status': row.regularizationRequestStatus,
                    'Regularization Type': row.regularizationType,
                    'Remark': row.remark_by_manager,
                    'Reason': row.remark_by_employee,
                }));

                const columns = [
                    { header: 'Employee Code', key: 'Employee Code', width: 30 },
                    { header: 'Employee Name', key: 'Employee Name', width: 30 },
                    { header: 'Date', key: 'Date', width: 20 },
                    { header: 'Punch In', key: 'Punch In', width: 15 },
                    { header: 'Punch Out', key: 'Punch Out', width: 15 },
                    { header: 'Shift', key: 'Shift', width: 20 },
                    { header: 'Working Hours', key: 'Working Hours', width: 20 },
                    { header: 'Deviation', key: 'Deviation', width: 20 },
                    { header: 'Location', key: 'Location', width: 20 },
                    { header: 'Department', key: 'Department', width: 20 },
                    { header: 'Attendance Status', key: 'Attendance Status', width: 20 },
                    { header: 'Action Status', key: 'Action Status', width: 20 },
                    { header: 'Regularization Type', key: 'Regularization Type', width: 20 },
                    { header: 'Remark', key: 'Remark', width: 40 },
                    { header: 'Reason', key: 'Reason', width: 40 },
                ];

                const wb = XLSX.utils.book_new();

                const ws = XLSX.utils.json_to_sheet(data, { header: columns.map(column => column.header) });

                ws['!cols'] = columns.map(column => ({ wch: column.width }));

                XLSX.utils.sheet_add_json(ws, data, { skipHeader: true, origin: 'A2' });

                columns.forEach((column, index) => {
                    ws[XLSX.utils.encode_cell({ r: 0, c: index })] = { v: column.header };
                });

                XLSX.utils.book_append_sheet(wb, ws, 'AbStart Attendance Report');

                // XLSX.writeFile(wb, `AbStartTeamAttendanceReport_(${Date()}).xlsx`);

                const date = new Date();
                const dateString = date.toLocaleDateString();
                const timeString = date.toLocaleTimeString();

                XLSX.writeFile(wb, `AbStartTeamAttendanceReport_(${formatDate(dateString)} ${timeString}).xlsx`);

                Swal.close();

                Swal.fire({
                    title: '<strong>Success</strong>',
                    html: 'Your file has been downloaded successfully.',
                    icon: 'success'
                });
            } else {
                Swal.close();
                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: response.data.message,
                    icon: 'error'
                });
            }
        })
            .catch((error) => {
                Swal.close();
                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: error.message,
                    icon: 'error'
                });
            });
    }


    resetForm = () => {
        this.setState({
            employee_leave_id: 0,
            employee_attendance_id: 0,
            employee_id: 0,
            employee_leave_from_date: '',
            employee_leave_to_date: '',
            employee_leave_document: '',
            employee_leave_reason: '',
            employee_leave_to_day_unit: '',
            employee_leave_from_day_unit: '',
            fileName: "",
            fileSize: "",
        });
    }

    handleInputSearch = () => {
        this.setState(
            {
                page: 1,
            },
            () => {
                this.GetList();
            }
        );
    }

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSelectChange = (name, selectedOption) => {
        this.setState((prevState) => ({
            [name]: selectedOption.value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };


    handlePrev = (ev) => {
        if (this.state.prev === true) {
            this.setState(
                (prevState) => {
                    return { page: prevState.page - 1 };
                },
                () => {
                    this.GetList();
                }
            );
        }
    };
    handleNext = () => {
        if (this.state.next === true) {
            this.setState(
                (prevState) => {
                    return { page: prevState.page + 1 };
                },
                () => {
                    this.GetList();
                }
            );
        }
    };
    handleChange = (e) => {
        this.setState(
            (prevState) => {
                return { page: parseInt(e.target.value, 10) };
            },
            () => {
                this.GetList();
            }
        );
    };

    handleClearAll = () => {
        this.setState(
            {
                rows: [],
                next: false,
                prev: false,
                page: 1,
                limit: 10,
                total_records: 0,
                total_pages: 0,
                loadingList: false,
                keyword: "",
                from_date: "",
                to_date: "",
                selectOption: '',
                location_id: '',
                department_id: '',
                month: parseInt(currentDateAndTime()?.split(" ")[0]?.split("-")[1]),
            },
            () => {
                this.GetList();
            }
        );
    };

    handleLimitChange = (e) => {
        this.setState(
            {
                limit: parseInt(e.target.value, 10),
                page: 1,
            },
            () => {
                this.GetList();
            }
        );
    };

    render() {
        const limitOptions = [10, 25, 50, 100, 200, 500, this.state.total_records];

        const options = [
            { value: '0', label: 'Absent' },
            { value: '1', label: 'Present' },
            { value: '2', label: 'Half Day' },
            // { value: '3', label: 'Regularized' },
            // { value: '4', label: 'Auto Regularized' },
            // { value: '5', label: 'Regularization Rejected' },
            // { value: '6', label: 'Late Mark' },
            // { value: '7', label: 'Early Mark' },
            // { value: '8', label: 'Leave' },
            // { value: '9', label: 'Holiday' },
        ];
        const { loadingLocation } = this.state;
        return (

            this.state.loadingList === false ?
                (<div className="main-content">
                    <div className='page-content'>
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={`Team Attendance Report`} primary={`Team Employees`} path={`/TeamEmployees`} />
                            <div className="row">

                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="row">
                                                <div className='col-md-3'>
                                                    <label htmlFor="keyword">Enter by Name</label>
                                                    <div className="input-group">
                                                        <input type="search" className="form-control" onChange={this.handleInputChange} name="keyword" value={this.state.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Search by Name" />
                                                        <button className="btn btn-success" onClick={this.handleInputSearch} type="button" id="button-addon2"><i className="ri-search-line"></i></button>
                                                    </div>
                                                </div>
                                                {/* <div className='col-md-3'>
                                                    <TextBox type="Date" id="from_date" name="from_date" label="From date" value={this.state.from_date} change={this.handleInputChange} />
                                                </div>
                                                <div className='col-md-3'>
                                                    <TextBox type="Date" id="to_date" name="to_date" label="To date" value={this.state.to_date} change={this.handleInputChange} />
                                                </div> */}

                                                <div className='col-md-2'>
                                                    <div className='position-relative'>
                                                        <div>
                                                            <label>Month</label>
                                                        </div>
                                                        <div style={{ "zIndex": 10, "width": "100%" }} className=' position-absolute'>
                                                            <Select
                                                                options={this.state.monthOptions}
                                                                value={this.state.month ? this.state.monthOptions.find(option => option.value === this.state.month) : null}
                                                                onChange={(selectOption) => this.setState({ month: selectOption?.value })}
                                                                hint={`Select Month`}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-md-2'>
                                                    <div className=' position-relative'>
                                                        <div>
                                                            <label>Status</label>
                                                        </div>
                                                        <div style={{ "zIndex": 10, "width": "100%" }} className=' position-absolute'>
                                                            <Select
                                                                onChange={(selectedOption) => this.handleSelectChange('selectOption', selectedOption)}
                                                                options={options}
                                                                value={this.state.selectOption ? options.find(option => option.value === this.state.selectOption) : null}
                                                                placeholder={`Select Status`}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-md-2'>
                                                    <div className=' position-relative'>
                                                        <div>
                                                            <label>Location</label>
                                                        </div>
                                                        <div style={{ "zIndex": 10, "width": "100%" }} className=' position-absolute'>
                                                            <Select
                                                                onChange={(selectedOption) => this.handleSelectChange('location_id', selectedOption)}
                                                                placeholder={`Select Location`}
                                                                options={this.state.location_rows}
                                                                value={this.state.location_id ? this.state.location_rows.find((option) => option.value === this.state.location_id) : null}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-md-3'>
                                                    <div className=' position-relative'>
                                                        <div>
                                                            <label>Department</label>
                                                        </div>
                                                        <div style={{ "zIndex": 10, "width": "100%" }} className=' position-absolute'>
                                                            <Select
                                                                onChange={(selectedOption) => this.handleSelectChange('department_id', selectedOption)}
                                                                placeholder={`Select Department`}
                                                                options={this.state.department_rows}
                                                                value={this.state.department_id ? this.state.department_rows.find((option) => option.value === this.state.department_id) : null}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="row">
                                                    <div style={{ width: "10%" }} className='col-md-2'>
                                                        <div>
                                                            <label>Apply Filter</label>
                                                        </div>
                                                        <button
                                                            type="button"
                                                            onClick={this.handleInputSearch}
                                                            className={`btn btn-info btn-label waves-effect waves-light ${(!this.state.keyword && !this.state.month && this.state.from_date === '' && this.state.to_date === '' && this.state.selectOption === '' && this.state.location_id === '' && this.state.department_id === '') ? 'disabled' : ''}`}>
                                                            <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                                            Filter
                                                        </button>
                                                    </div>
                                                    <div style={{ width: "10%" }} className='col-md-2'>
                                                        <div>
                                                            <label>Clear filter</label>
                                                        </div>
                                                        <button
                                                            type="button"
                                                            className={`btn btn-secondary btn-label waves-effect waves-light ${(!this.state.keyword && !this.state.month && this.state.from_date === '' && this.state.to_date === '' && this.state.selectOption === '' && this.state.location_id === '' && this.state.department_id === '') ? 'disabled' : ''}`}
                                                            onClick={this.handleClearAll}
                                                        >
                                                            <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i> Clear</button>
                                                    </div>
                                                    { this.state.decodedData?.includes(6) && ( 
                                                    <div className='col-md-3'>
                                                        <div>
                                                            <label>Export Excel</label>
                                                        </div>
                                                        <button
                                                            type="button"
                                                            onClick={this.handleExcelDownload}
                                                            className={`${this.state.rows.length === 0 ? ('disabled') : ""} btn btn-info btn-label waves-effect waves-light`}>
                                                            <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                            Export Excel
                                                        </button>
                                                    </div>)}
                                                </div>
                                                {/* <div className='col-md-3'>
                                                    <div className="row">
                                                        <div className='col-md-12'>
                                                            <div>
                                                                <label>Export Excel</label>
                                                            </div>
                                                            <button
                                                                type="button"
                                                                onClick={this.handleExcelDownload}
                                                                className={`${this.state.rows.length === 0 ? ('disabled') : ""} btn btn-info btn-label waves-effect waves-light`}>
                                                                <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                                Export Excel
                                                            </button>
                                                        </div>
                                                    </div>

                                                </div> */}
                                            </div>
                                        </div>
                                        <div ref={this.attendanceLocationInfoRef} className=" " >
                                            {/* <div className="card-header">
                                                </div> */}
                                            {loadingLocation === false ? (
                                                <div className={`${this.state.punch_in_date || this.state.punch_out_date ? '' : 'd-none'} card-header`}>
                                                    <h6 className={`${this.state.punch_in_date !== null ? '' : 'd-none'} card-title mb-3 d-flex align-items-center`}>
                                                        <span className='bx bx-log-in fs-3' style={{ marginRight: "10px" }} />
                                                        <span>Punch In Date : {this.state.punch_in_date} , Time : {this.state.punch_in_time}</span>
                                                    </h6>
                                                    <h6 className={`${this.state.punch_out_date !== null ? '' : 'd-none'} card-title mb-3 d-flex align-items-center`}>
                                                        <span className='bx bx-log-out fs-3' style={{ marginRight: "10px" }} />
                                                        <span>Punch Out Date : {this.state.punch_out_date} , Time : {this.state.punch_out_time}</span>
                                                    </h6>
                                                    <h6 className={`card-title`}>
                                                        <span className='ri ri-map-pin-2-line fs-3' style={{ marginRight: "10px" }}></span>
                                                        <span>{this.state.punch_in_date === null ? (this.state.punch_out_address) : this.state.punch_in_address}</span>
                                                    </h6>
                                                </div>) : (
                                                <div>
                                                    <div className="text-center mt-3">
                                                        <span className="text-info"><i className="mdi mdi-loading mdi-spin fs-1 align-middle me-2" /> Loading.....</span>
                                                    </div>

                                                </div>
                                            )}
                                        </div>
                                        <div className="card-body">
                                            <div className='card mt-3'>
                                                <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                                    <table style={{ minwidth: '100%' }} className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped text-center">
                                                        <thead className='bg-primary text-light bg-gradient position-sticky top-0 z-1'>
                                                            <tr>
                                                                <th className='noWrap'>Date</th>
                                                                <th className='noWrap'>Employee code</th>
                                                                <th className='noWrap'>Employee name</th>
                                                                <th className='noWrap'>Punch In</th>
                                                                <th className='noWrap'>Punch Out</th>
                                                                <th className='noWrap'>Shift</th>
                                                                <th className='noWrap'>Working Hours</th>
                                                                <th className='noWrap'>Deviation</th>
                                                                <th className='noWrap'>Attendance Status</th>
                                                                <th className='noWrap'>Location</th>
                                                                <th className='noWrap'>Department</th>
                                                                {this.state.decodedData?.includes(1) || this.state.decodedData?.includes(3) && (
                                                                <th className='noWrap'>Action</th>
                                                                )}
                                                                <th className='noWrap'>Action Status</th>
                                                                <th className='noWrap'>Regularization Type</th>
                                                                <th>Reason</th>
                                                                <th>Remark</th>
                                                            </tr>
                                                        </thead>
                                                        {this.state.rows.length === 0 ? (
                                                            <tbody>
                                                                <tr>
                                                                    <td colSpan={15}>
                                                                        <NoRecords />
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        ) :
                                                            <tbody>
                                                                {this.state.rows.map((row) => {
                                                                    return (
                                                                        <tr>
                                                                            <td className='noWrap'>{formatDate(row.attendance_date)}</td>
                                                                            <td className='noWrap'>{row.employee_code ? row.employee_code : "--"}</td>
                                                                            <td style={{ textAlign: "start" }} >{row.employee_name ? row.employee_name : "--"}</td>
                                                                            <td>
                                                                                <div className=" d-flex flex-column gap-0 justify-content-start">
                                                                                    <a className='text-info d-flex justify-content-start  noWrap' style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => {
                                                                                        if (row.punch_in_address) {
                                                                                            this.showInMap(row.punch_in_latlng, formatDate(row.PunchIn), formatTime(row.PunchIn), row.punch_in_address);
                                                                                            this.scrollToDiv();
                                                                                        }
                                                                                    }} href="#attendance">
                                                                                        <span className='noWrap'>{formatDate(row.PunchIn)} {formatTime(row.PunchIn)}</span>
                                                                                    </a>
                                                                                    <div style={{ width: "139px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                                        <small className=' noWrap'>{row.punch_in_address ? row.punch_in_address : row.PunchIn && !row.punch_in_address ? "Location is not captured." : "--"}</small>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td >
                                                                                <div className=" d-flex flex-column gap-0 justify-content-start">
                                                                                    <a className={`text-info d-flex justify-content-start  noWrap ${!row.PunchOut ? "d-none" : ""}`} style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => {
                                                                                        if (row.punch_out_address) {
                                                                                            this.showOutMap(row.punch_out_latlng, formatDate(row.PunchOut), formatTime(row.PunchOut), row.punch_out_address);
                                                                                            this.scrollToDiv();
                                                                                        }
                                                                                    }} href="#attendance">
                                                                                        <span className=' noWrap'>{formatDate(row.PunchOut)} {formatTime(row.PunchOut)}</span>
                                                                                    </a>
                                                                                    <div style={{ width: "139px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                                        <small className=' noWrap'>{row.punch_out_address ? row.punch_out_address : row.PunchOut && !row.punch_out_address ? "Location is not captured." : "--"}</small>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td className='noWrap'>{convertTo12HourFormat(row.ShiftStart)} - {convertTo12HourFormat(row.ShiftEnd)}</td>
                                                                            <td className='noWrap'>{row.WorkingHours ? getHoursAndMinutes(row.WorkingHours) : "--"}</td>
                                                                            <td>
                                                                                <span className={isNegativeDeviation(getHoursAndMinutes(row.Deviation)) ? 'text-danger noWrap' : 'noWrap'}>{row.Deviation ? getHoursAndMinutes(row.Deviation) : "--"}</span>
                                                                            </td>
                                                                            <td >
                                                                                {row.employee_leave_id ?
                                                                                    <span className={`badge bg-success`}>{row.leave_type_name}{this.checkIsLeave(row)}</span>
                                                                                    : <span className={`badge bg-${row?.calendar_festivals_name ? "secondary" : !row?.PunchIn && row?.ShiftWeekOff === "WeekOff" ? row?.ShiftWeekOffClasses : row.AttendanceStatusClasses}`}>{row?.calendar_festivals_name ? "Holiday" : !row?.PunchIn && row?.ShiftWeekOff === "WeekOff" ? row?.ShiftWeekOff : row.AttendanceStatus}</span>}
                                                                            </td>
                                                                            <td>{row.location_title ? row.location_title : "--"}</td>
                                                                            <td>{row.department_title ? row.department_title : "--"}</td>

                                                                            <td>
                                                                                <div className='d-flex justify-content-around'>
                                                                                    {
                                                                                        (
                                                                                            row.attendance_status === 0 ||
                                                                                            row.attendance_status === 2 ||
                                                                                            row.attendance_status === 5 ||
                                                                                            row.attendance_status === 6 ||
                                                                                            row.attendance_status === 7 ||
                                                                                            (row.regularization_request_status === 3 || row.regularization_request_status === null)
                                                                                        )
                                                                                            && getDaysDifference(formatDate(row.created_date)) <= this.state.rz_data.regularization_apply_days
                                                                                            && this.state.rz_data.rm_apply_regularization === '1' ?
                                                                                            (
                                                                                                <>
                                                                                                 {this.state.decodedData?.includes(3) && (
                                                                                                    <button
                                                                                                        type="button"
                                                                                                        className="btn btn-sm btn-outline-primary"
                                                                                                        data-bs-toggle="modal"
                                                                                                        data-bs-target="#exampleModalgrid"
                                                                                                        onClick={() => this.setState({
                                                                                                            employee_id: row.employee_id,
                                                                                                            employee_attendance_id: row.employee_attendance_id,
                                                                                                            attendance_regularization_request_id: row.attendance_regularization_request_id,
                                                                                                            modal_type: 1
                                                                                                        }, () => this.GetInfo())}
                                                                                                    >
                                                                                                        Regularize
                                                                                                    </button>)}
                                                                                                    {this.state.decodedData?.includes(1) && (
                                                                                                    <NavLink to={'/MyLeaves'}>
                        
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            className="btn btn-sm btn-success mx-3"
                                                                                                        >
                                                                                                            Leave
                                                                                                        </button>
                                                                                                    </NavLink>)}
                                                                                                </>
                                                                                            ) : ''
                                                                                    }
                                                                                    
                                                                                    {row.attendance_regularization_request_id && this.state.decodedData?.includes(1) &&
                                                                                        <button
                                                                                        type="button"
                                                                                        className="btn btn-sm btn-info"
                                                                                        data-bs-toggle="modal"
                                                                                        data-bs-target="#exampleModalgrid"
                                                                                        onClick={() => this.setState({ employee_id: row.employee_id, employee_attendance_id: row.employee_attendance_id, attendance_regularization_request_id: row.attendance_regularization_request_id, modal_type: 2 }, (prevState) => this.GetRegularizationLogs())}
                                                                                    >
                                                                                        Details
                                                                                    </button>}
                                                                                    
                                                                                </div>
                                                                            </td>
                                                                            <td ><span className={`badge bg-${row.regularizationRequestClasses}`}>{row.regularizationRequestStatus ? row.regularizationRequestStatus : "--"}</span></td>
                                                                            <td style={{ textAlign: "start" }} className='noWrap'>{row.regularizationType}</td>
                                                                            <td style={{ textAlign: "start" }} className={`${row.remark_by_manager?.length >= 30 ? "textEllipse" : "noWrap"}`}>{row.remark_by_employee ? row.remark_by_employee : "--"}</td>
                                                                            <td style={{ textAlign: "start" }} className={`${row.remark_by_manager?.length >= 30 ? "textEllipse" : "noWrap"}`}>{row.remark_by_manager ? row.remark_by_manager : "--"}</td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>}
                                                    </table>
                                                </div>
                                                <div className="d-flex justify-content-between align-items-center w-100 p-2">
                                                    <button
                                                        disabled={this.state.prev === false && this.state.loadingList === false ? true : false}
                                                        type="button"
                                                        onClick={() => this.handlePrev()}
                                                        className={`btn btn-warning btn-label waves-effect waves-light`}
                                                    >
                                                        <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                                        Previous
                                                    </button>
                                                    <div
                                                        className="col-md-4"
                                                        style={{ display: "flex", alignItems: "center" }}
                                                    >
                                                        {
                                                            <small>
                                                                Total Records: {this.state.total_records} |
                                                                Total Pages: {this.state.total_pages} |
                                                                Current Page: {this.state.page}
                                                            </small>
                                                        }
                                                    </div>
                                                    <div className="col-md-2">
                                                        <select
                                                            className="form-select"
                                                            onChange={(e) => this.handleChange(e)}
                                                        >
                                                            {Array.from(
                                                                { length: this.state.total_pages },
                                                                (_, i) => (
                                                                    <option
                                                                        selected={this.state.page === i + 1}
                                                                        key={i}
                                                                        value={i + 1}
                                                                    >
                                                                        Page {i + 1}
                                                                    </option>
                                                                )
                                                            )}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                                                            {limitOptions.map((option) => (
                                                                <option key={option} value={option}>
                                                                    Limit {option}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <button
                                                        disabled={
                                                            this.state.next === false &&
                                                                this.state.loadingList === false
                                                                ? true
                                                                : false
                                                        }
                                                        type="button"
                                                        onClick={() => this.handleNext()}
                                                        className={`btn btn-primary btn-label waves-effect right waves-light`}
                                                    >
                                                        <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                                        Next
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal fade" id="exampleModalgrid" tabIndex={-1} aria-labelledby="exampleModalgridLabel" aria-modal="true">
                                            <div className={this.state.modal_type === 1 ? `modal-dialog modal-lg` : `modal-dialog modal-xl`}>
                                                <div className="modal-content">
                                                    <div className="modal-header">
                                                        <h5 className="modal-title" id="exampleModalgridLabel">{this.state.modal_type === 1 ? `Regularize Attendance` : `Regularization Logs`}</h5>
                                                        <button type="button" className="btn-close" ref={this.closeRef} data-bs-dismiss="modal" aria-label="Close" />
                                                    </div>
                                                    <div className="modal-body">
                                                        {this.state.modal_type === 1 &&
                                                            <form onSubmit={this.handleSubmit}>
                                                                <div className="row mb-3">
                                                                    <div className="col-md-6">
                                                                        <label htmlFor="punch_in_datetime" className="form-label">Punch In DateTime</label>
                                                                        <input
                                                                            type="datetime-local"
                                                                            id="punch_in_datetime"
                                                                            name="punch_in_datetime"
                                                                            className="form-control"
                                                                            value={this.state.punch_in_datetime}
                                                                            onChange={this.handleInputChange}
                                                                            required={true}
                                                                        />
                                                                    </div>

                                                                    <div className="col-md-6">
                                                                        <label htmlFor="punch_out_datetime" className="form-label">Punch Out DateTime</label>
                                                                        <input
                                                                            type="datetime-local"
                                                                            id="punch_out_datetime"
                                                                            name="punch_out_datetime"
                                                                            className="form-control"
                                                                            value={this.state.punch_out_datetime}
                                                                            onChange={this.handleInputChange}
                                                                            required={true}
                                                                        />
                                                                    </div>

                                                                    <div className="col-md-12 mt-3">
                                                                        <label htmlFor="remark_by_employee" className="form-label">Remark</label>
                                                                        <textarea
                                                                            type="text"
                                                                            id="remark_by_employee"
                                                                            placeholder="Enter remark"
                                                                            name="remark_by_employee"
                                                                            className="form-control"
                                                                            value={this.state.remark_by_employee}
                                                                            onChange={this.handleInputChange}
                                                                            required={true}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex justify-content-end">
                                                                    <button type="submit" className="btn btn-success btn-label waves-effect right waves-light">
                                                                        <i className="bx bx-save label-icon align-middle fs-16 ms-2" /> Send </button>
                                                                </div>
                                                            </form>}
                                                        {this.state.modal_type === 2 && (
                                                            <>
                                                                {this.state.logs_data.length !== 0 ? (
                                                                    <table className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                                                                        <thead className='bg-primary text-light bg-gradient'>
                                                                            <tr>
                                                                                <th>Action Date</th>
                                                                                <th>Action By</th>
                                                                                <th>Requested Punch In</th>
                                                                                <th>Requested Punch Out</th>
                                                                                <th>Regularization Type</th>
                                                                                <th>Reason</th>
                                                                                <th>Remark</th>
                                                                                <th>Action Status</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {this.state.logs_data.map(log => (
                                                                                <tr key={log.attendance_regularization_request_log_id}>
                                                                                    <td>{formatDate(log.created_date)}</td>
                                                                                    <td>{log.employee_name}</td>
                                                                                    <td>{formatDate(JSON.parse(log.regularization_request_remark).punch_in_datetime) + ' - ' + formatTime(JSON.parse(log.regularization_request_remark).punch_in_datetime)}</td>
                                                                                    <td>{formatDate(JSON.parse(log.regularization_request_remark).punch_out_datetime) + ' - ' + formatTime(JSON.parse(log.regularization_request_remark).punch_out_datetime)}</td>
                                                                                    <td>{JSON.parse(log.regularization_request_remark).remark}</td>
                                                                                    <td>{log.regularizationType}</td>
                                                                                    <td>{log.regularized_by_remark || '---'}</td>
                                                                                    <td ><span className={`badge bg-${log.regularizationRequestClasses}`}>{log.regularizationRequestStatus}</span></td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>

                                                                ) : (
                                                                    <div>No Logs Found ...!</div>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                ) : <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>

        );
    }
}

export default withRouter(TeamsAttendanceReport);